import { ThemeMode } from '@modules/theme/constants';
import { lighten, useTheme } from '@mui/system';

interface EmptyDashboardPieIllustrationProps {
  isColored?: boolean;
}

export const EmptyDashboardPieIllustration = ({
  isColored = false,
}: EmptyDashboardPieIllustrationProps) => {
  const theme = useTheme();
  const isLightTheme = theme.palette.mode === ThemeMode.LIGHT;

  const pieFillOne = isLightTheme ? '#8d8d8d' : '#23222e';
  const pieFillTwo = isLightTheme ? '#757575' : '#2c2b37';
  const pieFillThree = isLightTheme ? '#a5a5a5' : '#3c3b47';
  const headerFill = isLightTheme ? '#C2C2C2' : '#2c2b37';
  const bodyFill = isLightTheme ? '#D5D5D5' : '#33323d';
  const strokeFill = lighten(theme.palette.background.paper, 0.3);

  return (
    <svg
      width="152"
      height="115"
      viewBox="0 0 264 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.636719"
        width="264"
        height="200"
        rx="8"
        fill={bodyFill}
        stroke={strokeFill}
        strokeWidth="2"
      />
      <path
        d="M123.763 53.6367C131.48 53.6367 139.121 55.1567 146.25 58.1098C153.38 61.0629 159.858 65.3913 165.314 70.8479C170.771 76.3046 175.099 82.7825 178.053 89.912C181.006 97.0414 182.526 104.683 182.526 112.4L123.763 112.4V53.6367Z"
        fill={isColored ? '#66bb6a' : pieFillTwo}
      />
      <path
        d="M123.763 53.6367C131.48 53.6367 139.121 55.1567 146.25 58.1098C153.38 61.0629 159.858 65.3913 165.314 70.8479C170.771 76.3046 175.099 82.7825 178.053 89.912C181.006 97.0414 182.526 104.683 182.526 112.4L123.763 112.4V53.6367Z"
        fill={isColored ? '#66bb6a' : pieFillTwo}
      />
      <path
        d="M177.741 89.1701C183.408 102.339 184.066 117.126 179.59 130.746C175.114 144.366 165.813 155.88 153.439 163.119L123.765 112.4L177.741 89.1701Z"
        fill={isColored ? '#ffa726' : pieFillThree}
      />
      <path
        d="M123.763 53.6367C136.172 53.6367 148.263 57.5653 158.303 64.8594L123.763 112.4V53.6367Z"
        fill={isColored ? '#8176ff' : pieFillOne}
      />
      <path
        d="M153.845 162.879C144.604 168.385 134.03 171.25 123.274 171.16C112.518 171.071 101.993 168.031 92.8457 162.372C83.6985 156.712 76.28 148.651 71.3988 139.066C66.5177 129.481 64.361 118.739 65.1639 108.013C65.9669 97.2867 69.6986 86.9864 75.9523 78.2348C82.2061 69.4832 90.7421 62.616 100.63 58.3816C110.518 54.1472 121.378 52.708 132.028 54.2209C142.677 55.7337 152.707 60.1406 161.025 66.9613L123.763 112.4L153.845 162.879Z"
        fill={isColored ? '#8176ff' : pieFillOne}
      />
      <circle cx="123.506" cy="112.659" r="44.0721" fill={bodyFill} />
      <path
        d="M0 8.63672C0 4.21844 3.58172 0.636719 8 0.636719H256C260.418 0.636719 264 4.21844 264 8.63672V31.6367H0V8.63672Z"
        fill={headerFill}
        stroke={strokeFill}
        strokeWidth="2"
      />
    </svg>
  );
};
